import styled from "styled-components";

export const Question = styled.h1`
    text-align: center;
    font-size: 24px;
`;

export const Story = styled.p`
    font-size: 16px;
    text-align: justify;
`;

export const GraphContainer = styled.section`
    margin-bottom: 22px;
`;

export const SectionHeaderBox = styled.div`
    background: #ffffff;
    border-radius: 16px;
    padding: 16px 18px;
    box-shadow: 0 12px 30px rgba(20, 33, 61, 0.08);
    margin-bottom: 16px;
`;
